import React from "react";
import Hero from "../components/Hero/Hero";
import Projects from "../components/Projects/Projects";
import About from "../components/About/About";
import Contact from "../components/Contact/Contact";
import Pricing from "../components/Pricing/Pricing";
import Footer from "../components/Footer/Footer";
import FixSocialIcon from "../components/SocialIcon/FixSocialIcon";
function Home() {
  return (
    <>

      <Hero />


      <Projects />
      <About />
      <Pricing />
      <Contact />
      <Footer />
      <FixSocialIcon />

    </>
  );
}

export default Home;
